import { useState } from "react";

// material-ui
import { Box, Button, IconButton } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

// assets
import { SearchRounded } from "@mui/icons-material";
import SearchModal from "../SearchModal";

const SearchSection = (): React.ReactElement => {
  const [searchOpen, setSearchOpen] = useState(false);

  const handleSearchClose = (): void => {
    setSearchOpen(false);
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          position: "relative",
          // border: "2px solid black",
          flexGrow: 1,
        }}
      >
        <Button
          onClick={() => {
            setSearchOpen(true);
          }}
          startIcon={<SearchIcon />}
          sx={{
            borderRadius: "1rem",
            width: {
              xs: 200,
              sm: 250,
              lg: 300,
            },
            justifyContent: "start",
            // py: 1,
            display: {
              xs: "none",
              md: "flex",
            },
            fontSize: 14,
            fontWeight: 500,
          }}
          color="error"
          variant="outlined"
        >
          Search...
        </Button>

        <IconButton
          color="error"
          sx={{
            display: {
              md: "none",
            },
          }}
          onClick={() => {
            setSearchOpen(true);
          }}
        >
          <SearchRounded fontSize="large" />
        </IconButton>
      </Box>

      <SearchModal open={searchOpen} handleClose={handleSearchClose} />

    </>
  );
};

export default SearchSection;
